// extracted by mini-css-extract-plugin
export default {"products":"ps-z","card":"qs-z","oosMessaging":"rs-z"};